$(function () {

    AOS.init();

    SearchModal.init();
    VideoListing.init();
    Gallery.init();
});